

























































































import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import Vue from 'vue';
import { ListMaintenanceService } from '@/services/ListMaintenanceService';
import { ListMaintenanceConfigurationModel } from '@/types/models/listMaintenance/ListMaintenanceConfigurationModel';
import { BvTableFieldArray } from 'bootstrap-vue';
import { mapActions, mapGetters } from 'vuex';
import {
  ConfigurationChangeModel,
  StoreConstants,
  DefaultFieldDefinitions,
  TableFilterModel,
  TableSortModel,
  StickyStoreNames,
  StickySettingsGetters,
  StickySettingsActions,
  ListMaintenanceStateFields,
  ListConfigurationModel,
  ListType,
  Configuration
} from '@/types';
import MStoreMakeChangesLock from '@/components/shared/MStoreMakeChangesLock.vue';
import MStoreColumnFilter from '@/components/shared/Table/MStoreColumnFilter.vue';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { MStoreTableUtils } from '@/utils';

export default Vue.extend({
  name: 'ListMaintenance',
  data() {
    return {
      isLoading: true,
      listMaintenanceConfiguration: {} as ListMaintenanceConfigurationModel,
      sortOptions: [] as TableSortModel[],
      filterOptions: [] as TableFilterModel[],
      isFetchingListMaintenanceConfiguration: false,
      appliedSortOptions: []
    };
  },
  computed: {
    ...mapGetters(StoreConstants.ConfigurationChange.ModuleName, [
      StoreConstants.ConfigurationChange.Getters.BypassConfigurationChangeLock,
      StoreConstants.ConfigurationChange.Getters.ConfigurationChange,
      StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLock,
      StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLockedByCurrentSession,
      StoreConstants.ConfigurationChange.Getters.ConfigurationChangeIsLoading
    ]),
    ...mapGetters(StickyStoreNames.ListMaintenance, [StickySettingsGetters.GetStickyStateField]),
    isEditMode(this: any) {
      return this[StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLockedByCurrentSession];
    },
    lock(this: any) {
      return this[StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLock];
    },
    bypassLockingOnToolkit(this: any) {
      return this[StoreConstants.ConfigurationChange.Getters.BypassConfigurationChangeLock];
    },
    isLockLoading(this: any) {
      return this[StoreConstants.ConfigurationChange.Getters.ConfigurationChangeIsLoading];
    },
    items(this: any) {
      return this.lists ?? [];
    },
    columns(this: any) {
      return this.listMaintenanceConfiguration ? ([DefaultFieldDefinitions.Actions, ...this.listMaintenanceConfiguration.columns] as BvTableFieldArray) : [];
    },
    filterFields(this: any) {
      return this.listMaintenanceConfiguration.columns as BvTableFieldArray;
    },
    canMaintain(this: any) {
      return this.listMaintenanceConfiguration?.canMaintain ?? false;
    },
    canConfigure(this: any) {
      return this.listMaintenanceConfiguration?.canConfigure ?? false;
    },
    itemsPerPage(this: any) {
      return this[StickySettingsGetters.GetStickyStateField](ListMaintenanceStateFields.ItemsPerPage);
    },
    currentPage(this: any) {
      return this[StickySettingsGetters.GetStickyStateField](ListMaintenanceStateFields.CurrentPage);
    },
    showFilters(this: any) {
      return this[StickySettingsGetters.GetStickyStateField](ListMaintenanceStateFields.ShowFilters);
    },
    showSorting(this: any) {
      return this[StickySettingsGetters.GetStickyStateField](ListMaintenanceStateFields.ShowSorting);
    },
    filteredSortedItems(this: any) {
      const allItems = this.items;
      const filterOptions = this[StickySettingsGetters.GetStickyStateField](ListMaintenanceStateFields.FilterOptions);
      const sortOptions = this[StickySettingsGetters.GetStickyStateField](ListMaintenanceStateFields.SortOptions);
      const filteredItems = MStoreTableUtils.applyDefaultFiltering(allItems, filterOptions);
      const filteredSortedItems = MStoreTableUtils.applyDefaultSorting(filteredItems, sortOptions);
      return filteredSortedItems;
    }
  },
  methods: {
    ...mapActions(StoreConstants.ConfigurationChange.ModuleName, [
      StoreConstants.ConfigurationChange.Actions.BeginChange,
      StoreConstants.ConfigurationChange.Actions.EndChange,
      StoreConstants.ConfigurationChange.Actions.GetChangeWithErrorPage
    ]),
    ...mapActions(StickyStoreNames.ListMaintenance, [StickySettingsActions.SetStickyStateField, StickySettingsActions.ResetStickyState]),
    async onChangeReasonEntered(this: any, changeReason: string) {
      try {
        await this[StoreConstants.ConfigurationChange.Actions.BeginChange]({
          controllerPath: this.CHANGE_CONTROLLER_PATH,
          configurationChange: {
            description: changeReason
          } as ConfigurationChangeModel
        });
      } catch (error) {
        this.$log(error);
      }
    },
    async onReleaseLock(this: any) {
      await this[StoreConstants.ConfigurationChange.Actions.EndChange](this.CHANGE_CONTROLLER_PATH);
    },
    addBuiltInList() {
      this.$log('addBuiltInList');
    },
    addSqlList() {
      this.$log('addSqlList');
    },
    updateFilter(this: any, index: number, filter: TableFilterModel) {
      Vue.set(this.filterOptions, index, filter);
    },
    addFilter(this: any) {
      this.filterOptions = [...(this.filterOptions as TableFilterModel[]), { key: '', columnFilterType: '' }] as TableFilterModel[];
    },
    clearFilters(this: any) {
      const filterFields: TableFilterModel[] = this.filterOptions;
      this.filterOptions = filterFields.map(({ key, columnFilterType }) => ({
        key,
        columnFilterType,
        value: ''
      }));
    },
    resetFilters(this: any) {
      this.filterOptions = [];
      this.applyFilters();
    },
    applyFilters(this: any) {
      this[StickySettingsActions.SetStickyStateField]({ field: ListMaintenanceStateFields.FilterOptions, value: [...this.filterOptions] });
    },
    removeFilter(this: any, index: number) {
      this.filterOptions.splice(index, 1);
    },
    onSortingApplied(this: any) {
      this.sortItems();
    },
    updateSortItem(this: any, index: number, sortOption: TableSortModel) {
      Vue.set(this.sortOptions, index, { ...sortOption });
    },
    addSortItem(this: any, sortOption?: TableSortModel) {
      this.sortOptions.push(sortOption || { sortingKey: '', isSortingAscending: true });
    },
    deleteSortOption(this: any, index: number) {
      this.sortOptions.splice(index, 1);
    },
    resetSort(this: any) {
      this.sortOptions = [] as TableSortModel[];
      this.sortItems();
    },
    sortItems(this: any) {
      const usedFields = new Set();
      for (const option of this.sortOptions) {
        if (option.sortingKey === '') {
          SnotifyConfiguration.showError('Not all sorting options have a field selected');
          return;
        }

        if (usedFields.has(option.sortingKey)) {
          const columnDescription = this.queueColumns.find((x: any) => x.key === option.sortingKey).label;
          SnotifyConfiguration.showError(`Cannot sort on the same field (${columnDescription}) twice`);
          return;
        } else {
          usedFields.add(option.sortingKey);
        }
      }
      this.appliedSortOptions = this.sortOptions;
      this[StickySettingsActions.SetStickyStateField]({ field: ListMaintenanceStateFields.SortOptions, value: [...this.sortOptions] });
    },
    onShowSorting(this: any) {
      this[StickySettingsActions.SetStickyStateField]({ field: ListMaintenanceStateFields.ShowSorting, value: !this.showSorting });
    },
    onShowFilters(this: any) {
      this[StickySettingsActions.SetStickyStateField]({ field: ListMaintenanceStateFields.ShowFilters, value: !this.showFilters });
    },
    onUpdateItemsPerPage(this: any, _: string, value: number) {
      this[StickySettingsActions.SetStickyStateField]({ field: ListMaintenanceStateFields.ItemsPerPage, value });
    },
    onUpdateCurrentPage(this: any, _: string, value: number) {
      this[StickySettingsActions.SetStickyStateField]({ field: ListMaintenanceStateFields.CurrentPage, value });
    },
    async getListMaintenanceConfiguration(this: any) {
      this.isFetchingListMaintenanceConfiguration = true;
      try {
        this.listMaintenanceConfiguration = await ListMaintenanceService.getListMaintenanceServiceConfiguration();
        this.lists = (this.listMaintenanceConfiguration as ListMaintenanceConfigurationModel).lists.map(({ id, description, listType }) => ({
          id,
          description,
          listType: listType === ListType.BuiltIn ? 'Built In' : 'SQL'
        }));
      } catch (error) {
        this.$log(error);
      } finally {
        this.isLoading = false;
        this.isFetchingListMaintenanceConfiguration = false;
      }
    },
    maintainList(item: ListConfigurationModel) {
      this.$router.push({ name: Configuration.ListMaintenance.MaintainBuiltInListItems.name, params: { listId: item.id.toString() } });
    },
    configureList(item: any) {
      console.log('configure', item);
    },
    deleteList(item: any) {
      console.log('delete', item);
    }
  },
  async mounted(this: any) {
    this[StoreConstants.ConfigurationChange.Actions.GetChangeWithErrorPage](this.CHANGE_CONTROLLER_PATH);
    this.filterOptions = this[StickySettingsGetters.GetStickyStateField](ListMaintenanceStateFields.FilterOptions) ?? [];
    this.sortOptions = this[StickySettingsGetters.GetStickyStateField](ListMaintenanceStateFields.SortOptions) ?? [];
    this.appliedSortOptions = this.sortOptions;
    try {
      await this.getListMaintenanceConfiguration();
    } catch (error) {
      this.$log(error);
    } finally {
      this.isLoading = false;
    }
  },
  created(this: any) {
    this.CHANGE_CONTROLLER_PATH = 'listMaintenanceConfiguration';
  },
  components: { MStoreTable, LoadingSpinner, MStoreMakeChangesLock, MStoreColumnFilter }
});
